module.exports = __webpack_public_path__ + "d5af39e8d1762d550ec9949c0c6b652d.svg";


//////////////////
// WEBPACK FOOTER
// ./components/main/logo.svg
// module id = Sq+B
// module chunks = 0